export const actions = {
  resetCode: 'resetCode',

  resetApp: 'resetApp',
  resetApi: 'resetApi',
  resetSlice: 'resetSlice',
  resetApiSlice: 'resetApiSlice',
  resetApiStatusSlice: 'resetApiStatusSlice',
  refresh: 'refresh',

  login: 'login',
  switchUser: 'switchUser',
  updateUser: 'updateUser',
  logout: 'logout',
  logoutCurrent: 'logoutCurrent',

  mfaRequired: 'mfaRequired',
  created: 'created',
  success: 'success',
  warning: 'warning',
  error: 'error',
  retry: 'retry',
  redirect: 'redirect',
  timeout: 'timeout',
} as const;

export type AppAction = (typeof actions)[keyof typeof actions];

export const ActionType = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
} as const;

export type AppActionType = (typeof ActionType)[keyof typeof ActionType];

export const keepUnusedDataFor = 86400;
